module.exports = __webpack_public_path__ + "img/user-admin-bai.188d2385.svg";